module.exports = __webpack_public_path__ + "img/7.c7e689a8.svg";